import { Button, styled } from "@material-ui/core";

export const CancelButton = styled( (p) =>
    <Button {...p} color="inherit">
        Cancel
    </Button>
)(({theme}) => ({
    marginRight: theme.spacing(0.5),
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 0.6,
    textTransform: 'uppercase',
    minWidth: 'auto',
}));


export const AddButton = styled( ({isSaving, ...p}: any) =>
    <Button {...p} color="inherit" disabled={isSaving || false}>
        {isSaving ? 'Adding...' : 'Add'}
    </Button>
)(({theme}) => ({
    marginLeft: theme.spacing(0.5),
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: 0.6,
    textTransform: 'uppercase',
    minWidth: 'auto',
}));
